// extracted by mini-css-extract-plugin
export default {"container":"TestTemplate_container__L7Kef","multiNode":"TestTemplate_multiNode__hdXk0"};